import { Item } from './item';
import { Location } from './location';

export interface InventoryItem {
  id: string;
  item: Item;
  location: Location;
  quantity: number;
  reorderLevel: number;
  lastUpdated: string;
}

export enum StockTransactionType {
  STOCK_IN = 'STOCK_IN',
  DISPENSED = 'DISPENSED',
  DISPOSED = 'DISPOSED',
  TRANSFER_OUT = 'TRANSFER_OUT',
  TRANSFER_IN = 'TRANSFER_IN'
}

export interface StockTransaction {
  id: string;
  transactionNumber: string;
  transactionType: StockTransactionType;
  item: Item;
  quantity: number;
  fromLocation?: Location;
  toLocation?: Location;
  reference?: string; // For linking to prescriptions, orders, etc.
  notes?: string;
  createdBy: string;
  createdAt: string;
}

export interface StockInFormData {
  itemId: string;
  locationId: string;
  quantity: number;
  batchNumber?: string;
  expiryDate?: string;
  notes?: string;
}

export interface StockOutFormData {
  itemId: string;
  fromLocationId: string;
  quantity: number;
  transactionType: StockTransactionType.DISPENSED | StockTransactionType.DISPOSED | StockTransactionType.TRANSFER_OUT;
  toLocationId?: string; // Required for TRANSFER_OUT
  reference?: string;
  notes?: string;
}

export interface StockLevel {
  itemId: string;
  locationId: string;
  quantity: number;
  item: Item;
  location: Location;
}
